var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("navbar"),
      _vm._v(" "),
      _c("main", { staticClass: "main", attrs: { role: "main" } }, [
        _c("div", { staticClass: "py-5 bg-light" }, [
          _c("div", { staticClass: "container" }, [
            _c(
              "div",
              { staticClass: "col-md-12 p-0" },
              [
                _c("router-link", { attrs: { to: "top" } }, [
                  _vm._v(_vm._s(_vm.$t("ordertop.myhome")))
                ]),
                _vm._v(" / "),
                _c("router-link", { attrs: { to: "order" } }, [
                  _vm._v(_vm._s(_vm.$t("top.myorder")))
                ]),
                _vm._v(
                  " / " +
                    _vm._s(_vm.$t("OrderCreate.OrderCreate")) +
                    "\n          "
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-4 col-12 col-sm-9 col-md-7 col-lg-6 pl-0 pr-0"
                  },
                  [
                    _c("ul", { staticClass: "nav nav-tabs wizard pl-0 pr-0" }, [
                      _c(
                        "li",
                        {
                          class: {
                            active: _vm.step === 1,
                            completed: _vm.step > 1
                          }
                        },
                        [_c("a", [_vm._v(_vm._s(_vm.$t("OrderCreate.Terms")))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          class: {
                            active: _vm.step === 2,
                            completed: _vm.step > 2
                          }
                        },
                        [_c("a", [_vm._v(_vm._s(_vm.$t("OrderCreate.Input")))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          class: {
                            active: _vm.step === 3,
                            completed: _vm.step > 3
                          }
                        },
                        [
                          _c("a", [
                            _vm._v(_vm._s(_vm.$t("OrderCreate.Confrim")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("li", { class: { active: _vm.step >= 4 } }, [
                        _c("a", [
                          _vm._v(_vm._s(_vm.$t("OrderCreate.Complete")))
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.step === 1
                  ? _c("div", [
                      _c("div", { staticClass: "card mt-4" }, [
                        _c("div", { staticClass: "card-body pb-2 pr-0" }, [
                          _c("h4", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("OrderTerms.TermsTitle")) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "privacyPolicy-scroll-bar" },
                            [
                              _c(
                                "div",
                                { staticClass: "pt-4 col-10 offset-1 p-0" },
                                [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "privacyPolicy.registerPrivacyPolicy"
                                        )
                                      )
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group mt-4" }, [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("div", { staticClass: "input-group-text" }, [
                            _c("input", {
                              attrs: {
                                id: "confirm",
                                type: "checkbox",
                                "aria-label":
                                  "Checkbox for following text input"
                              },
                              domProps: { checked: _vm.confirmed },
                              on: {
                                click: function($event) {
                                  _vm.confirmed = !_vm.confirmed
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-control",
                            staticStyle: { width: "auto", flex: "none" },
                            attrs: {
                              type: "text",
                              "aria-label": "Text input with checkbox",
                              for: "confirm"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("OrderTerms.confirmed")))]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.step === 2 || _vm.step == 3
                  ? _c("div", [
                      _c("div", { staticClass: "card mt-4" }, [
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", {}, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("OrderCreate.text")) + " ")
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card mt-4 pt-3 pb-3" }, [
                        _c("div", { staticClass: "card-body" }, [
                          _c(
                            "nav",
                            { staticClass: "navbar navbar-light col-12 " },
                            [
                              _c("div", { staticClass: "col-12 col-lg-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "amountOfCurrency" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("OrderCurrency.amountOfCurrency")
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-sm border-0",
                                    attrs: {
                                      tabindex: "0",
                                      role: "button",
                                      "data-toggle": "popover",
                                      "data-trigger": "focus",
                                      title: _vm.$t(
                                        "OrderCurrency.amountOfCurrency"
                                      ),
                                      "data-content": _vm.$t(
                                        "OrderCurrency.amountOfCurrencyTips"
                                      )
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../static/img/info.svg")
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-inline col-12 col-lg-8 p-0"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "dropdown show" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-secondary dropdown-toggle",
                                                  class: {
                                                    disabled: _vm.step == 3
                                                  },
                                                  staticStyle: {
                                                    "border-top-right-radius":
                                                      "0em",
                                                    "border-bottom-right-radius":
                                                      "0em"
                                                  },
                                                  attrs: {
                                                    href: "#",
                                                    role: "button",
                                                    id: "dropdownMenuLink",
                                                    "data-toggle": "dropdown",
                                                    "aria-haspopup": "true",
                                                    "aria-expanded": "false"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(_vm.currency) +
                                                      "\n                          "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "dropdown-menu",
                                                  attrs: {
                                                    "aria-labelledby":
                                                      "dropdownMenuLink"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      attrs: { href: "#" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.currency = "BTC"
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "OrderCurrency.BTC"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.number,
                                            expression: "number"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "amountOfCurrency",
                                          type: "number",
                                          step: "0.001",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: { value: _vm.number },
                                        on: {
                                          change: _vm.changeNum,
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.number = $event.target.value
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("nav", { staticClass: "navbar col-12" }, [
                            _c("div", { staticClass: "col-12 col-lg-4 " }, [
                              _c(
                                "label",
                                {
                                  staticClass: "navbar-brand",
                                  attrs: { for: "referenceExchangeRate" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "OrderCurrency.referenceExchangeRate"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-sm border-0",
                                  attrs: {
                                    tabindex: "0",
                                    role: "button",
                                    "data-toggle": "popover",
                                    "data-trigger": "focus",
                                    title: _vm.$t(
                                      "OrderCurrency.referenceExchangeRate"
                                    ),
                                    "data-content": _vm.$t(
                                      "OrderCurrency.referenceExchangeRateTips"
                                    )
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../static/img/info.svg")
                                    }
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-inline col-12 col-lg-8 p-0"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group col-12 " },
                                  [
                                    _c("input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        id: "referenceExchangeRate",
                                        "aria-label": "Recipient's username",
                                        "aria-describedby": "basic-addon2",
                                        readonly: ""
                                      },
                                      domProps: { value: _vm.rate }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "input-group-text",
                                            attrs: { id: "basic-addon2" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("orderlist.USD")) +
                                                "/" +
                                                _vm._s(_vm.currency)
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("nav", { staticClass: "navbar col-12" }, [
                            _c("div", { staticClass: "col-12 col-lg-4" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "navbar-brand",
                                  attrs: { for: "budgetEstimate" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("OrderCurrency.budgetEstimate")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-sm border-0",
                                  attrs: {
                                    tabindex: "0",
                                    role: "button",
                                    "data-toggle": "popover",
                                    "data-trigger": "focus",
                                    title: _vm.$t(
                                      "OrderCurrency.budgetEstimate"
                                    ),
                                    "data-content": _vm.$t(
                                      "OrderCurrency.budgetEstimateTips"
                                    )
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../static/img/info.svg")
                                    }
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-inline col-12 col-lg-8 p-0"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group col-12 " },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-prepend" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "input-group-text",
                                            attrs: { id: "basic-addon2" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("orderlist.USD"))
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "budgetEstimate",
                                        type: "text",
                                        "aria-describedby": "basic-addon2",
                                        readonly: ""
                                      },
                                      domProps: {
                                        value: (_vm.rate * _vm.number).toFixed(
                                          2
                                        )
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("nav", { staticClass: "navbar col-12" }, [
                            _c("div", { staticClass: "col-12 col-lg-4" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "navbar-brand",
                                  attrs: { for: "serviceCharge" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("OrderCurrency.serviceCharge")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-sm border-0",
                                  attrs: {
                                    tabindex: "0",
                                    role: "button",
                                    "data-toggle": "popover",
                                    "data-trigger": "focus",
                                    title: _vm.$t(
                                      "OrderCurrency.serviceCharge"
                                    ),
                                    "data-content": _vm.$t(
                                      "OrderCurrency.serviceChargeTips"
                                    )
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../static/img/info.svg")
                                    }
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-inline col-12 col-lg-8 p-0"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group col-12" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-prepend" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "input-group-text",
                                            attrs: { id: "basic-addon2" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("orderlist.USD"))
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "serviceCharge",
                                        type: "text",
                                        "aria-describedby": "basic-addon2",
                                        readonly: ""
                                      },
                                      domProps: { value: _vm.getServiceCharge }
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.step === 4
                  ? _c("div", [
                      _c("div", { staticClass: "p-0 card mt-4 pt-3 pb-3" }, [
                        _c(
                          "div",
                          { staticClass: "p-5 text-center" },
                          [
                            _c("p", { staticClass: "lead" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ApplicationCompleted.Applicationcompleted"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("hr", { staticClass: "my-4 display-4" }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.$t("ApplicationCompleted.pointOut"))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "btn btn-lg btn-primary",
                                attrs: { to: "/user/order" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("ApplicationCompleted.ReturnButton")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row no-gutters mt-4 col-12 p-0" }, [
              _c("div", { staticClass: "col-6" }, [
                _vm.step <= 3
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-outline-secondary mr-3 col-5 col-md-4 col-lg-2",
                        on: { click: _vm.clickBack }
                      },
                      [_vm._v(_vm._s(_vm.$t("OrderTerms.BackButton")))]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 text-right p-0" }, [
                _vm.step < 3 && (_vm.rate * _vm.number).toFixed(2) < 1000000
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary col-5 col-md-4 col-lg-2",
                        attrs: {
                          disabled:
                            !_vm.confirmed ||
                            (_vm.step === 2 && _vm.number == 0)
                        },
                        on: {
                          click: function($event) {
                            _vm.step++
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("OrderTerms.NextButton")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                (_vm.rate * _vm.number).toFixed(2) >= 1000000
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn-primary col-5 col-md-4 col-lg-2",
                        attrs: {
                          href: "#",
                          "data-toggle": "modal",
                          "data-target": "#messageModal"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("OrderTerms.NextButton")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.step === 3
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn-success col-5 col-md-4 col-lg-2",
                        attrs: {
                          href: "#",
                          "data-toggle": "modal",
                          "data-target": "#authenticatorModal"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("OrderTerms.CreateButton")))]
                    )
                  : _vm._e()
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("copyright"),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "demo-ruleForm needs-validation",
          attrs: { "label-width": "0px", novalidate: "" }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: {
                id: "authenticatorModal",
                tabindex: "-1",
                role: "dialog",
                "aria-labelledby": "authenticatorModalLabel",
                "aria-hidden": "true"
              }
            },
            [
              _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "h4",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "authenticatorModalLabel" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("TwiceVerification.twiceVerification")
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body pt-5 pb-5" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "TwiceVerification.verificationCodeExplainOrder"
                            )
                          )
                        )
                      ]),
                      _c("br"),
                      _c("br"),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "verificationCodeStep2" } }, [
                        _c("h5", [
                          _vm._v(
                            _vm._s(_vm.$t("TwiceVerification.verificationCode"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.verificationCode,
                            expression: "verificationCode"
                          }
                        ],
                        staticClass: "form-control form-control-lg mt-2",
                        attrs: { id: "verificationCodeStep2", required: "" },
                        domProps: { value: _vm.verificationCode },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.verificationCode = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "TwiceVerification.verificationCodeRequired"
                              )
                            ) +
                            "\n              "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer pt-5 pb-3" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-lg btn-outline-secondary",
                          attrs: { type: "button", "data-dismiss": "modal" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("modal.modalCancel")) +
                              "\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-lg btn-primary",
                          attrs: { type: "submit" },
                          on: { click: _vm.create }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("TwiceVerification.modalSubmit"))
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "messageModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "messageModalLabel",
            "aria-hidden": "true"
          }
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h4",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "messageModalLabel" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("orderListPopup.Messgae")) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body pt-5 pb-5" }, [
                _c("label", [
                  _c("h5", [_vm._v(_vm._s(_vm.$t("OrderCurrency.traded")))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer pt-5 pb-3" }, [
                _c("div", { staticClass: "col-6 text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg btn-primary",
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v(_vm._s(_vm.$t("modal.modalOk")))]
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-588ad10c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-588ad10c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/order-create.vue
// module id = null
// module chunks = 